import {
  GoogleMap,
  InfoWindow,
  Marker,
  useJsApiLoader,
} from "@react-google-maps/api";
import Config from "config";
import React, { useState } from "react";
import { prepareDataForProopertyBox } from "../common/PropertyBox";

const pagesLink = Config.pagesLink;
const mediaURLPrefix = Config.mediaURLPrefix;
const defaultThumbnailURL = Config.defaultThumbnailURL;
const $ = window.$;

const containerStyle = {
  width: "100%",
  height: "100%",
};

const GMap = (props) => {
  if (!props.PropertiesInfoRelated) {
    console.log("No PropertiesInfoRelated");
    return <></>;
  }
  // if (!props.Latitude || props.Longtitude) {
  //     return <></>;
  // }
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: Config.googleMapsApiKey, //"AIzaSyA0uJQ7h2b5odArgx9eK08v7pyx6gEqWsk",//"AIzaSyCuSBXCxCZDt6h33hXun8k5j9Dgadj47kE",
  });

  const [center, setCenter] = useState({
    lat: parseFloat(props.Latitude),
    lng: parseFloat(props.Longtitude),
  });

  const [map, setMap] = React.useState(null);

  const [mainPin, setMainPin] = React.useState({
    url: "/SiteCollectionDocuments/assets/PFS2022/pages/detail/img/marker.png",
    size: { height: 34.15, width: 45.68 },
    scaledSize: { height: 34.15, width: 45.68 },
    anchor: { x: 0, y: 45.68 },
  });

  const [pin, setPin] = React.useState({
    url: "/SiteCollectionDocuments/assets/PFS2022/pages/detail/img/marker-2.png",
    size: { height: 17.45, width: 26 },
    scaledSize: { height: 17.45, width: 26 },
    anchor: { x: 0, y: 26 },
  });

  const [activeMarker, setActiveMarker] = useState(null);

  const handleActiveMarker = (marker) => {
    console.log("handleMarker", marker);
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  // useEffect(()=>{
  //     handleActiveMarker(props.PropertyID)
  // },[props.PropertyID])

  const renderMarker = (props) => {
    if (props.PropertiesInfoRelated) {
      return props.PropertiesInfoRelated.map((item, index) => {
        return (
          <Marker
            key={item.PropertyID}
            position={{
              lat: parseFloat(item.Latitude),
              lng: parseFloat(item.Longtitude),
            }}
            onClick={() => handleActiveMarker(item.PropertyID)}
            icon={pin}
          >
            {activeMarker === item.PropertyID ? (
              <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                <RenderInfoWindow {...item} />
              </InfoWindow>
            ) : null}
          </Marker>
        );
      });
    }
    return <></>;
  };

  const onLoad = React.useCallback(
    function callback(map) {
      // const bounds = new google.maps.LatLngBounds();
      // if (props.PropertiesInfoRelated) {
      //     props.PropertiesInfoRelated.forEach(({ Latitude, Longtitude }) => bounds.extend({ Latitude, Longtitude }));
      // }
      // map.fitBounds(bounds);
      const mainPin = {
        url: "/SiteCollectionDocuments/assets/PFS2022/pages/detail/img/marker.png",
        size: new google.maps.Size(34.15, 45.68),
        scaledSize: new google.maps.Size(34.15, 45.68),
        anchor: new google.maps.Point(0, 45.68),
      };
      const pin = {
        url: "/SiteCollectionDocuments/assets/PFS2022/pages/detail/img/marker-2.png",
        size: new google.maps.Size(17.45, 26),
        scaledSize: new google.maps.Size(17.45, 26),
        anchor: new google.maps.Point(0, 26),
      };

      setMainPin(mainPin);
      setPin(pin);

      var controlDiv = $(`<div class="legend">
        <div class="pin-notice">
            <img src="${mainPin.url}" alt="ทรัพย์สินปัจจุบันที่เลือก" />
            <span>: ทรัพย์สินปัจจุบันที่เลือก</span>
        </div>
        <div class="pin-notice">
            <img src="${pin.url}" alt="ทรัพย์สินปัจจุบันที่เลือก" />
            <span>: ทรัพย์สินใกล้เคียง</span>
        </div>
    </div>`);
      map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(controlDiv[0]);
      handleActiveMarker(props.PropertyID);
      setMap(map);
    },
    [props.PropertiesInfoRelated]
  );

  function makeid(length) {
    var result = "";

    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    var charactersLength = characters.length;

    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }

  console.log("Google map render");
  if (!isLoaded) return <></>;

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      zoom={12}
      center={center}
      onLoad={onLoad}
      onClick={() => setActiveMarker(null)}
    >
      <Marker
        key={props.PropertyID}
        position={{
          lat: parseFloat(props.Latitude),
          lng: parseFloat(props.Longtitude),
        }}
        onClick={() => handleActiveMarker(props.PropertyID)}
        icon={mainPin}
      >
        {activeMarker === props.PropertyID ? (
          <InfoWindow onCloseClick={() => setActiveMarker(null)}>
            <RenderInfoWindow {...props} />
          </InfoWindow>
        ) : null}
      </Marker>
      {renderMarker(props)}
    </GoogleMap>
  );
};
//, arePropertiesInfoRelatedEqual)

export const MyGoogleMap = React.memo(GMap, arePropertiesInfoRelatedEqual);

function arePropertiesInfoRelatedEqual(prevProps, nextProps) {
  if (
    prevProps.PropertiesInfoRelated?.length !==
    nextProps.PropertiesInfoRelated?.length
  ) {
    return false;
  }
  return true;
}

const RenderInfoWindow = (property) => {
  var {
    propertyDetailURL,
    thumbnailURL,
    location,
    propertyName,
    tag,
    PromotionPrice,
    Price,
    areaHtml,
    bedRoomHtml,
    propertyTypeHtml,
    PropertyIDFormat,
  } = prepareDataForProopertyBox(property);

  return (
    <>
      <div className="map-btn-wrapper">
        <button
          type="button"
          className="more-filter-btn map pxtm-clickEvent"
          aria-label="Close"
        >
          <img src="/SiteCollectionDocuments/assets/PFS2022/theme/img/icon/close-filter.svg" />
        </button>
      </div>
      <div id="infowindow-content">
        <div className="md-thumbnail-slide">
          <div className="md-thumbnail-img">
            <img
              src={thumbnailURL}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = defaultThumbnailURL;
              }}
              alt="Asset"
              loading="lazy"
            />
          </div>
          <div className="md-thumbnail-detail">
            <a href={propertyDetailURL}>
              <h3 className="asset-title">{propertyName}</h3>
            </a>
            {location && (
              <div className="location mb-1">
                <i className="ic-npa ic-npa-icon-pin"></i>
                <p>{location}</p>
              </div>
            )}
            <div className="map-detail-prop">
              {tag}
              <div>
                {PromotionPrice}
                {Price}
              </div>
            </div>
            {/* <p className="asset-code mb-2">รหัส {PropertyIDFormat}</p>
            <div className="d-flex align-items-start justify-content-between mb-2">
                {tag}
                <div>
                    {PromotionPrice}
                    {Price}
                </div>

            </div> */}
          </div>
        </div>
        <div className="map-get-direction">
          <a
            href={void 0}
            onClick={(e) =>
              mapNavButtonClicked(property.Latitude, property.Longtitude)
            }
            data-kbct="link_click"
            data-kblb="see_route"
            data-kbgp="detail"
            data-kbsc="detail"
          >
            กดดูเส้นทาง
          </a>
        </div>
      </div>
    </>
  );
};

function mapNavButtonClicked(Latitude, Longtitude) {
  if (!navigator.geolocation) {
    window.openErrorPopup("เว็บเบราว์เซอร์ของท่านไม่สามารถใช้งานฟีเจอร์นี้ได้");
  }

  navigator.geolocation.getCurrentPosition(
    function (position) {
      var latitude = position.coords.latitude;
      var longitude = position.coords.longitude;
      var url =
        "https://www.google.com/maps/dir/?api=1&origin=" +
        latitude +
        "," +
        longitude +
        "&destination=" +
        Latitude +
        "," +
        Longtitude +
        "&travelmode=driving";

      //var a = $('<a>').attr('href', url).attr('target', '_blank').css('display', 'none');
      //$('body').append(a);
      //a[0].click();

      window.open(url, "_blank");

      // $('#mapLink').attr('href', url)[0].click();
    },
    function (err) {
      var alertMessage;

      if (err.code === 1) {
        alertMessage =
          "โปรดตั้งค่าเพื่ออนุญาตให้หน้าเว็บดึงตำแหน่งของท่าน แล้วลองใหม่อีกครั้ง";
      } else {
        alertMessage = "ไม่สามารถดึงตำแหน่งปัจจุบันของท่านได้";
      }

      window.openErrorPopup(alertMessage);
    }
  );
}
